const enum ProductTaskCommonIds {
  DesignBenefit = 1,
  CompleteProfile = 2,
  EnrollEmployees = 3,
  FinalizeBenefit = 4,
  InviteEmployees = 5,
}
export default ProductTaskCommonIds
